import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { getUserData } from '@/redux/modules/user';
import { useAppSelector } from '@/redux/hooks';
import { useLocation } from 'react-router-dom';
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import styles from './SuspendedBidderBanner.module.scss';

const SuspendedBidderBanner = () => {
    const { pathname } = useLocation();
    const biddingConsole = pathname.includes('/console/');
    const { creditCardValidated, hasEverRegisteredForAuction, standing } = useAppSelector(getUserData);
    const show = !biddingConsole && standing === 's' && (creditCardValidated || hasEverRegisteredForAuction);
    return show ? (
        <div className={styles.banner}>
            <div className={styles['banner-inner']}>
                <div className={styles.text}>
                    <FormattedMessage id="suspendedBidderBanner.text" />
                </div>
                <ButtonLink
                    className={styles.submit}
                    external
                    primary
                    target="_blank"
                    url="https://help.liveauctioneers.com/article/146-how-do-i-restore-my-suspended-account"
                >
                    <FormattedMessage id="suspendedBidderBanner.button" />
                </ButtonLink>
            </div>
        </div>
    ) : null;
};

export default SuspendedBidderBanner;
